import * as React from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import type { InjectedFormProps } from 'redux-form';

import MaterialMarkupsAdjustmentModal from 'af-root/scenes/Company/Shared/Materials/MaterialMarkupsAdjustmentModal';

import { MATERIAL_COMPANY_MARKUP_UPSERT } from 'af-constants/reduxForms';

import * as MaterialCompanyMarkupHistoryActions from 'af-actions/materialCompanyMarkupHistory';

import MaterialCompanyMarkupFM from './formModel';

interface OwnProps {
	initialValues: Nullable<Partial<MaterialCompanyMarkupFM>>;
	showModal: boolean;
	onSubmitSuccess: () => void;
	close: () => void;
}

type Props = OwnProps & ConnectedProps<typeof connector> & InjectedFormProps<MaterialCompanyMarkupFM>;

const MaterialCompanyMarkupAdjustmentModal: React.FC<Props> = (props) => {
	const { close, handleSubmit, showModal, upsert, onSubmitSuccess: onSubmit, initialize, initialValues, valid } = props;

	React.useEffect(() => {
		if (showModal) {
			initialize(new MaterialCompanyMarkupFM(initialValues ?? undefined));
		}
	}, [initialValues, initialize, showModal]);

	const upsertMaterialCompanyMarkup = React.useCallback(async (form: MaterialCompanyMarkupFM) => {
		await upsert(MaterialCompanyMarkupFM.toRM(form));
		onSubmit();
		close();
	}, [close, onSubmit, upsert]);

	const formUpsert = React.useMemo(() => handleSubmit(upsertMaterialCompanyMarkup), [handleSubmit, upsertMaterialCompanyMarkup]);

	const handleFormSubmit = React.useCallback(() => {
		formUpsert();
	}, [formUpsert]);

	return (
		<MaterialMarkupsAdjustmentModal
			close={close}
			level="Company"
			onSubmit={handleFormSubmit}
			showModal={showModal}
			submitDisabled={!valid}
		/>
	);
};

function mapDispatchToProps() {
	return {
		upsert: MaterialCompanyMarkupHistoryActions.upsert,
	};
}

const connector = connect(null, mapDispatchToProps());

const formConnector = reduxForm({
	form: MATERIAL_COMPANY_MARKUP_UPSERT,
	validate: MaterialCompanyMarkupFM.validate,
});

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector,
	formConnector
);

export default enhance(MaterialCompanyMarkupAdjustmentModal);
